import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import singleChoice from '@/views/questionnaire/customerManage/questionnaireList/components/singleChoice.vue';
import tableControl from '@/views/questionnaire/customerManage/questionnaireList/components/tableControl.vue';
import multipleChoice from '@/views/questionnaire/customerManage/questionnaireList/components/multipleChoice.vue';
// import emailSendModel from '@/views/components/emailSend/emailSendModel.vue';
import dateControl from '@/views/questionnaire/customerManage/questionnaireList/components/dateControl.vue';
import dropDownSelect from '@/views/questionnaire/customerManage/questionnaireList/components/dropDownSelect.vue';
import signModel from '@/views/questionnaire/customerManage/questionnaireList/components/signModel.vue'; //签名组件
import paragraphModel from '@/views/questionnaire/customerManage/questionnaireList/components/paragraphModel.vue'; //段落
import enclosureModel from '@/views/questionnaire/customerManage/questionnaireList/components/enclosureModel.vue'; //附件
// import {generateValidateRule} from '@/views/questionnaire/customerManage/questionnaireList/util.js';
import { countriesDATA, planArea, logisticsData, bankData } from '@/views/examine/auditManage/request';
import topTitle from '@/components/title';
import formItemMixin from '@/mixins/formItemMixin';
export default {
  props: {
    editableArea: {
      type: Array,
      default() {
        return [];
      }
    },
    echoNodeIsEdit: {
      type: Boolean,
      default: false //false不可以编辑true可编辑
    }
  },
  mixins: [formItemMixin],
  components: {
    singleChoice,
    tableControl,
    multipleChoice,
    // emailSendModel,
    dateControl,
    dropDownSelect,
    signModel,
    paragraphModel,
    enclosureModel,
    topTitle
  },
  created() {
    this.getOptions();
    this.editableArea.forEach(item2 => {
      item2.form.forEach(control => {
        var _controlItem$associat;
        if (control.controlType === 'control') {
          var _control$control;
          control.control.mark = (_control$control = control.control) === null || _control$control === void 0 ? void 0 : _control$control.mark.replace('d.', 'd_');
          if (control.control.partsType === 'multipleChoice') {
            let value = control.control.value || [];
            this.$set(this.formData, control.control.mark, value);
            // control.control.numberLimit = '2,3';
          } else {
            this.$set(this.formData, control.control.mark, control.control.value || undefined);
          }
        } else {
          control.mark = control.mark.replace('d.', 'd_');
          let groupControl = control.control;
          groupControl.forEach(item => {
            item.mark = item.mark.replace('d.', 'd_');
            if (item.partsType === 'multipleChoice') {
              let value = item.value || [];
              this.$set(this.formData, item.mark, value);
              // control.control.numberLimit = '2,3';
            } else {
              this.$set(this.formData, item.mark, item.value || undefined);
            }
          });
        }
        //设置控件显隐 以及处理关联关系
        let mark = control.controlType === 'control' ? control.control.mark : control.mark;
        let controlItem = control.controlType === 'control' ? control.control : control;
        if ((controlItem === null || controlItem === void 0 || (_controlItem$associat = controlItem.association) === null || _controlItem$associat === void 0 || (_controlItem$associat = _controlItem$associat.association) === null || _controlItem$associat === void 0 ? void 0 : _controlItem$associat.length) > 0) {
          let key = controlItem.association.association[0].hideControl.replace('d.', 'd_');
          let value = controlItem.association.association[0];
          value.targetKey = mark;
          this.associationInfo[key] = value;
          this.$set(this.showControl, mark, false);
        } else {
          this.$set(this.showControl, mark, true);
        }
      });
    });
    this.formatRules();
  },
  data() {
    return {
      formData: {},
      showControl: {},
      rules: {},
      countriesData: [],
      provinceFirstLevel: [],
      bankData: [],
      logisticsData: [],
      provinceArea: null,
      provinceData: [],
      associationInfo: {},
      vidateStatus: true
    };
  },
  methods: {
    formatRules() {
      this.editableArea.forEach(item2 => {
        item2.form.forEach(item3 => {
          if (item3.controlType === 'control') {
            let rules = generateValidateRule(item3.control);
            if (rules.length > 0) {
              this.$set(this.rules, item3.control.mark, rules);
            }
          } else if (item3.controlType === 'controlGroup') {
            item3.control.forEach(item4 => {
              let rules = generateValidateRule(item4);
              if (rules.length > 0) {
                this.$set(this.rules, item4.mark, rules);
              }
            });
          }
        });
      });
    },
    async getOptions() {
      let resource = [countriesDATA({}), planArea({
        level: 1,
        type: 'noAll'
      }), planArea({
        level: 2,
        type: 'noAll'
      }), planArea({
        level: 3,
        type: 'noAll'
      }), bankData({
        level: 1
      }), logisticsData({
        level: 1
      })];
      const loop = (data, obj) => {
        data.forEach(item => {
          obj[item.code] = item.name;
          if (item.children) {
            loop(item.children, obj);
          }
        });
        return obj;
      };
      await Promise.all(resource).then(res => {
        this.countriesData = res[0] || [];
        this.countriesDataMap = loop(res[0], {});
        this.provinceFirstLevel = res[1] || [];
        this.provinceFirstLevelObj = loop(res[1], {});
        this.provinceData = res[2] || [];
        this.provinceDataObj = loop(res[2], {});
        this.provinceArea = res[3] || [];
        this.provinceAreaObj = loop(res[3], {});
        this.bankData = res[4] || [];
        this.bankDataObj = loop(res[4], {});
        this.logisticsData = res[5] || [];
        this.logisticsDataObj = loop(res[5], {});
      });
    },
    changeControlShow(value, key) {
      this.$set(this.showControl, key, value);
    },
    // handleControlValue(controlItem) {
    //   //处理控件的value值
    //   if (controlItem.partsType === 'table' && this.showControl[controlItem.mark]) {
    //     controlItem.controlValue = this.$refs[`table${controlItem.mark}`][0].formDataArray;
    //     this.$refs[`table${controlItem.mark}`][0].generationData2();
    //     controlItem.mark = controlItem.mark.replace('d_', 'd.');
    //   } else if (controlItem.partsType === 'dropDown') {
    //     let value = this.formData[controlItem.mark];
    //     controlItem.value = this.handleDropDownData(value, controlItem);
    //     controlItem.mark = controlItem.mark.replace('d_', 'd.');
    //   } else {
    //     controlItem.value = this.formData[controlItem.mark];
    //     controlItem.mark = controlItem.mark.replace('d_', 'd.');
    //   }
    // },
    onSubmit() {
      let tableValidateStatus = this.validateTable();
      if (!tableValidateStatus) {
        this.vidateStatus = false;
        return;
      }
      // console.log(this.$refs.form, 'this.$refs.form');
      this.$refs.form.validate(valid => {
        this.vidateStatus = valid;
        // console.log(this.vidateStatus, valid, 'valid');
        if (valid) {
          this.editableArea.forEach(nodeItem => {
            nodeItem.form.forEach(controlItem => {
              if (controlItem.controlType === 'controlGroup') {
                controlItem.control.forEach(item => {
                  this.handleControlValue(item);
                });
              } else {
                this.handleControlValue(controlItem.control);
              }
            });
          });
          // console.log(this.formData);
        }
      });
    },
    validateTable() {
      //验证表格数据
      this.editableArea.forEach(nodeItem => {
        nodeItem.form.forEach(controlItem => {
          // console.log('---current---', controlItem);
          if (controlItem.controlType === 'controlGroup') {
            //控件组
            controlItem.control.forEach(item => {
              if (item.partsType === 'table' && this.showControl[item.mark]) {
                this.$refs[`table${item.mark}`][0].validateForm();
              }
            });
          } else if (controlItem.control.partsType === 'table' && this.showControl[controlItem.control.mark]) {
            this.$refs[`table${controlItem.control.mark}`][0].validateForm();
          }
        });
      });
      let validateStatus = true;
      for (let m = 0; m < this.editableArea.length; m++) {
        let nodeItem = this.editableArea[m];
        for (let j = 0; j < nodeItem.form.length; j++) {
          let controlItem = nodeItem.form[j];
          if (controlItem.controlType === 'controlGroup') {
            //控件组
            for (let k = 0; k < controlItem.control.length; k++) {
              let item = controlItem.control[k];
              if (item.partsType === 'table' && this.showControl[item.mark]) {
                if (!this.$refs[`table${item.mark}`][0].validateStatus) {
                  validateStatus = false;
                }
                if (!validateStatus) {
                  break;
                }
              }
            }
          } else if (controlItem.control.partsType === 'table' && this.showControl[controlItem.control.mark]) {
            if (!this.$refs[`table${controlItem.control.mark}`][0].validateStatus) {
              validateStatus = false;
            }
          }
          if (!validateStatus) {
            break;
          }
        }
        if (!validateStatus) {
          break;
        }
      }
      return validateStatus;
    },
    generateTableData() {
      this.editableArea.forEach(nodeItem => {
        nodeItem.form.forEach(controlItem => {
          if (controlItem.control.partsType === 'table' && this.showControl[controlItem.control.mark]) {
            this.$refs[`table${controlItem.control.mark}`][0].generationData2();
          } else if (controlItem.control.partsType === 'controlGroup') {
            controlItem.control.forEach(item => {
              if (item.partsType === 'table' && this.showControl[item.mark]) {
                this.$refs[`table${item.mark}`][0].generationData2();
              }
            });
          }
        });
      });
    }
  }
};